var benefits = {
    items: [
        {
            head: "הטבות",
            name: "הטבות",
            ref: "https://drive.google.com/file/d/1ADTiRwPJlraRVRoC3quLsyNrnLmLssv8/view?usp=drive_link",
            showImage: false,
        },
        {
            head: "הטבות",
            name: "הטבות למימוש",
            ref: "https://drive.google.com/file/d/1q3MXdqY0uQVsq3ez8EwYTbz3y6SaW28G/view?usp=drive_link",
            showImage: false,
        }
    ],
};

var businessDevelopment = {
    items: [
        {
            head: "פיתוח עסקי",
            name: "רוני יונג",
            ref: "https://drive.google.com/file/d/1PlTwKyFwtpI7ZE76dSJuMM9ncoYlnIx5/view?usp=drive_link",
            showImage: false,
        },
        {
            head: "פיתוח עסקי",
            name: "יובל פינקס",
            ref: "https://drive.google.com/file/d/1EBNR-G9CuVkimBTt5Dh-zVdpn8Qkpmh2/view?usp=drive_link",
            showImage: false,
        },
        {
            head: "פיתוח עסקי",
            name: "אלון גל",
            ref: "https://drive.google.com/file/d/1LHKqAAQVLObC0VWdtKUe8vK6PWAn28s6/view?usp=drive_link",
            showImage: false,
        }
    ],
};

var whatsUnion = {
    items: [
        {
            head: "מהו האיגוד",
            name: "מהות האיגוד",
            ref: "https://drive.google.com/file/d/1GbX3kaYB-GF9O7Hgc_Qwzt8WEbhWhEix/view?usp=drive_link",
            showImage: false,
        },
        {
            head: "מהו האיגוד",
            name: "צוות האיגוד",
            ref: "https://drive.google.com/file/d/1cNaLpUXA-GzL1ilaw0FWZK4K9sPSCtva/view?usp=drive_link",
            showImage: false,
        },
        {
            head: "מהו האיגוד",
            name: "הטבות לחברים",
            ref: "https://drive.google.com/file/d/1ADTiRwPJlraRVRoC3quLsyNrnLmLssv8/view?usp=drive_link",
            showImage: false,
        },
        {
            head: "מהו האיגוד",
            name: "דבר המערכת",
            ref: "https://drive.google.com/file/d/1PiwWHaj3MiUmmV3kIEFQT7ILkHyj_AK5/view?usp=drive_link",
            showImage: false,
        },
    ],
};

var hiveOfExperts = {
    items: [
        {
            head: "כוורת מומחים I.F.O",
            name: "כוורת מומחים",
            ref: "https://drive.google.com/file/d/11qH8rf6BrLWxBEQe12MdYmo9PWeCIIoy/view?usp=drive_link",
            showImage: false,
        },
    ],
};

var legalRepresentation = {
    items: [
        {
            head: "המייצג המשפטי של האיגוד עו״ד גו׳ן גבע",
            name: "המייצג המשפטי של האיגוד עו״ד גו׳ן גבע",
            ref: "https://drive.google.com/file/d/16bUhHxcNQa5UqashyxD5m0p_DCOh5JFF/view?usp=drive_link",
            showImage: false,
        },
    ],
};

var diploma = {
    items: [
        {
            head: "תעודת הסמכה",
            name: "קריטריון לתעודת הסמכה",
            ref: "https://drive.google.com/file/d/13JOBflqi5eS-8AkiMLl4cnXoKSugTZyX/view?usp=drive_link",
            showImage: false,
        },
        {
            head: "תעודת הסמכה",
            name: "תעודת הסמכה",
            ref: "https://drive.google.com/file/d/1d8qk0m0PhNYeTwKdquDzwSLs_sKeeqyp/view?usp=drive_link",
            showImage: false,
        },
    ]
}

var professionalGroups = {
    items: [
        {
            head: "קבוצות המקצועיות של האיגוד",
            name: "הקבוצות המקצועיות שלנו",
            ref: "https://drive.google.com/file/d/1gvLN12yv3ImuhteGevfyjFLjD47RlJZp/view?usp=drive_link",
            showImage: false,
        }
    ]
}

var Year2026 = {
    items: [
        {
            head: "המרחב המקצועי 2026",
            name: "הכשרת בריאות",
            ref: "https://drive.google.com/file/d/1OdGEVt9x4vJE5oEAC0G7qvWnAFoDh09i/view?usp=drive_link",
            showImage: false,
        },
        {
            head: "המרחב המקצועי 2026",
            name: "הכשרת פיננסים/השקעות",
            ref: "https://drive.google.com/file/d/1jlTjsvVI1HWyeHu22nJpsKYOtMw0vrTv/view?usp=drive_link",
            showImage: false,
        },
        {
            head: "המרחב המקצועי 2026",
            name: "הכשרת AI",
            ref: "https://drive.google.com/file/d/15H7O0xgWW0aMML8QsHOjviU2HXSTJ9gm/view?usp=drive_link",
            showImage: false,
        },
        {
            head: "המרחב המקצועי 2026",
            name: "זום מקצועי עם רו״ח רונית כהן",
            ref: "https://drive.google.com/file/d/1rMPqEw_1E1tbaQja4S5RQrFxS5IQpqIj/view?usp=drive_link",
            showImage: false,
        },
        {
            head: "המרחב המקצועי 2026",
            name: "מפגשי מומחי הכוורת מרץ",
            ref: "https://drive.google.com/file/d/1z3mwCWL5TWYSRdmfzATxbf8xCn7E8Su-/view?usp=drive_link",
            showImage: false,
        },
        {
            head: "המרחב המקצועי 2026",
            name: "מפגשי מומחי הכוורת אפריל",
            ref: "https://drive.google.com/file/d/1ia_Kcb0m7eI8YtyKnPsV1iYgIcLFfAu3/view?usp=drive_link",
            showImage: false,
        },
        {
            head: "המרחב המקצועי 2026",
            name: "סדנת פיתוח עיסקי",
            ref: "https://drive.google.com/file/d/1YLyV6Vdla_3MVPZpuPMrAYRhCXmzRtIX/view?usp=drive_link",
            showImage: false,
        },
        {
            head: "המרחב המקצועי 2026",
            name: "מפגשי מומחי הכוורת מאי",
            ref: "https://drive.google.com/file/d/1SIm93BqxVTHltrnpqHYHfzlY3-1l9vkr/view?usp=sharing",
            showImage: false,
        },
        {
            head: "המרחב המקצועי 2026",
            name: "מפגשי מומחי הכוורת יוני",
            ref: "https://drive.google.com/file/d/1RHxf59i6S8FtNYBXXX9OwcsfBkmyIheC/view?usp=drive_link",
            showImage: false,
        },
        {
            head: "המרחב המקצועי 2026",
            name: "מפגשי מומחי הכוורת יולי",
            ref: "https://drive.google.com/file/d/1pZLku6774I-r7kd5lOdI8AIF30-x1yjw/view?usp=drive_link",
            showImage: false,
        },
        {
            head: "המרחב המקצועי 2026",
            name: "מפגשי מומחי הכוורת אוגוסט",
            ref: "https://drive.google.com/file/d/1JrCJyCtVvPgLYdqk6EwWhW-Ewj2Ci56W/view?usp=drive_link",
            showImage: false,
        },
    ]
}

var Year2025 = {
    items: [
        {
            head: "הדרכות מקצועיות ברמה חודשית לשנת 2025",
            name: "ינואר",
            ref: "https://drive.google.com/file/d/1nwR0mZMI6tlS1bpzNhzee6fL-8OtlRNu/view?usp=drive_link",
            showImage: false,
        },
        {
            head: "הדרכות מקצועיות ברמה חודשית לשנת 2025",
            name: "פברואר",
            ref: "https://drive.google.com/file/d/1eyRSMZUoIzDjqZzkiyxy5RVtNEhtflls/view?usp=drive_link",
            showImage: false,
        },
        {
            head: "הדרכות מקצועיות ברמה חודשית לשנת 2025",
            name: "מרץ",
            ref: "https://drive.google.com/file/d/1K_7E1MSy0baUdJs-LKnUUdeHBOOBD7Nc/view?usp=drive_link",
            showImage: false,
        },
        {
            head: "הדרכות מקצועיות ברמה חודשית לשנת 2025",
            name: "אפריל",
            ref: "https://drive.google.com/file/d/1YF2mKt3ScAdr7lFiMxrr5A6z0pUaW-UD/view?usp=sharing",
            showImage: false,
        },
        {
            head: "הדרכות מקצועיות ברמה חודשית לשנת 2025",
            name: "מאי",
            ref: "https://drive.google.com/file/d/1dGEp8EkFoWaZqPjesmDfK6liZS7jVo4n/view?usp=sharing",
            showImage: false,
        },
        {
            head: "הדרכות מקצועיות ברמה חודשית לשנת 2025",
            name: "יוני",
            ref: "https://drive.google.com/file/d/1ENcV3Sw5y99KoxHK0bmRkrSkmEa8F2qL/view?usp=drive_link",
            showImage: false,
        },
    ]
}

var Year2024 = {
    items: [
        {
            head: "הדרכות מקצועיות ברמה חודשית לשנת 2024",
            name: "הדרכות נובמבר",
            ref: "https://drive.google.com/file/d/1CyKcw0d7_zd9c3ma8zI0gOzdByMHRLJA/view?usp=drive_link",
            showImage: false,
        },
        {
            head: "הדרכות מקצועיות ברמה חודשית לשנת 2024",
            name: "הדרכות דצמבר",
            ref: "https://drive.google.com/file/d/1pVNHv756TtUawO2BZBdDcIX8UxNVdoCU/view?usp=drive_link",
            showImage: false,
        },
        {
            head: "הדרכות מקצועיות ברמה חודשית לשנת 2024",
            name: "הפקדות והערכות לסוף שנת 2024",
            ref: "https://drive.google.com/file/d/1vvajXWV0kjYuoWI2w4QGG4gFSObhOudX/view?usp=drive_link",
            showImage: false,
        },
    ]
}

var Newsletters = {
    items: [
        {
            head: "ניוזלטר חודשי I.F.O",
            name: "אפריל",
            ref: "https://online.fliphtml5.com/qgqwg/bslo/",
            showImage: false,
        },
        {
            head: "ניוזלטר חודשי I.F.O",
            name: "מאי",
            ref: "https://online.fliphtml5.com/qgqwg/akow/",
            showImage: false,
        },
        {
            head: "ניוזלטר חודשי I.F.O",
            name: "יוני",
            ref: "https://online.fliphtml5.com/qgqwg/rbvh/",
            showImage: false,
        },
        {
            head: "ניוזלטר חודשי I.F.O",
            name: "יולי",
            ref: "https://online.fliphtml5.com/leilg/lqzr/",
            showImage: false,
        },
    ]
}

var professionalSpace = {
    items: [
        {
            head: "המרחב המקצועי של האיגוד",
            name: "סיעור מוחות על הבר",
            ref: "https://drive.google.com/file/d/1C62bdF3QH0Kzz5tYCke30m-LhIoqPDOH/view?usp=drive_link",
            showImage: false,
        },
        {
            head: "המרחב המקצועי של האיגוד",
            name: "זום השקה איגוד",
            ref: "https://drive.google.com/file/d/1IjCxnFGabHy0rdma3-JN1ZqZCkWOtxvq/view?usp=drive_link",
            showImage: false,
        },
        {
            head: "המרחב המקצועי של האיגוד",
            name: "הפקדה לפיצויים",
            ref: "https://drive.google.com/file/d/13ZIj74schHyymvpVaIIdOESexnKPKbWa/view?usp=drive_link",
            showImage: false,
        },
    ]
}

var realizationBenefits = {
    items: [
        {
            head: "כיצד מממשים הטבות",
            name: "כיצד מממשים הטבות",
            ref: "https://drive.google.com/file/d/1eDauyzvvVVUeDTvq2ggcwNqcqON5vMl3/view?usp=drive_link",
            showImage: false,
        }
    ]
}

var publishedArticles = {
    items: [
        {
            head: "כתבות שפורסמו בעיתונות",
            name: "פאנדר",
            ref: "https://drive.google.com/file/d/1q1TJuKP6BIjWbNMayHFwJfSLhQFsoS3f/view?usp=drive_link",
            showImage: false,
        },
        {
            head: "כתבות שפורסמו בעיתונות",
            name: "פוליסה",
            ref: "https://drive.google.com/file/d/15MGX5jP6n3cz-oac34J7uTI1VOXhd9i5/view?usp=drive_link",
            showImage: false,
        },
        {
            head: "כתבות שפורסמו בעיתונות",
            name: "עדיף",
            ref: "https://drive.google.com/file/d/1Z4OJvs2T2BZeeTO7H43Hjm4F-3CuT2BQ/view?usp=drive_link",
            showImage: false,
        },
    ]
}

var associationIncorporation = {
    items: [
        {
            head: "איגוד על הבר",
            name: "איציק בן ארויה",
            ref: "https://drive.google.com/file/d/1TWITvPeAPxSnb96ynXQ5RvHGPl8GcLBW/view?usp=drive_link",
            showImage: false,
        },
        {
            head: "איגוד על הבר",
            name: "חני שפיס",
            ref: "https://drive.google.com/file/d/1bbW7hRkVVKFIDw9f0O0686uXPvlO3x90/view?usp=drive_link",
            showImage: false,
        },
        {
            head: "איגוד על הבר",
            name: "פטריקס - גמר ליגת האלופות",
            ref: "https://drive.google.com/file/d/16eQa5M8eLlAgLU-UcI6qgaufJc8hMMoK/view?usp=sharing",
            showImage: false,
        },
    ]
}

var Events = {
    items: [
        {
            head: "אירועים I.F.O",
            name: "פטריקס מונדיאל I.F.O",
            ref: "https://drive.google.com/file/d/1vXr1QJArW6noH2pkh69vYiySvexnMufb/view?usp=drive_link",
            showImage: false,
        }
    ]
}

var VertHotelConference = {
    items: [
        {
            head: "כנס איגוד מלון VERT ירושלים 2026",
            name: "הזמנה",
            ref: "https://drive.google.com/file/d/1vXr1QJArW6noH2pkh69vYiySvexnMufb/view?usp=drive_link",
            showImage: false,
        },
        {
            head: "כנס איגוד מלון VERT ירושלים 2026",
            name: "לו״ז",
            ref: "https://drive.google.com/file/d/1d3FHquufNBnO_8JOL17RYDoEC1YXXsIm/view?usp=drive_link",
            showImage: false,
        }
    ]
}

var danHotelConference = {
    items: [
        {
            head: "כנס איגוד מלון דן ירושלים 2025",
            name: "תמונות מהכנס 1",
            ref: "https://drive.google.com/file/d/1y0mnWU6pewFntNSdEjjhMr1Ms3lznOd8/view?usp=drive_link",
            showImage: false,
        },
        {
            head: "כנס איגוד מלון דן ירושלים 2025",
            name: "תמונות מהכנס 2",
            ref: "https://drive.google.com/file/d/1g03J88soJ_5UDU0MO8sg2_tWFBaGpT3r/view?usp=drive_link",
            showImage: false,
        },
        {
            head: "כנס איגוד מלון דן ירושלים 2025",
            name: "תמונות מהכנס 3",
            ref: "https://drive.google.com/file/d/1obuFzMU3FTPY55mKx25s-shyDa_rKjzi/view?usp=drive_link",
            showImage: false,
        },
        {
            head: "כנס איגוד מלון דן ירושלים 2025",
            name: "תמונות מהכנס 4",
            ref: "https://drive.google.com/file/d/1M3TisRTo6qQO-oWrzpEIHtk3bXDmh4Tx/view?usp=drive_link",
            showImage: false,
        },
    ]
}

var eilatConferenceArticles = {
    items: [
        {
            head: "כתבות כנס אילת",
            name: "כתבה 1",
            ref: "https://drive.google.com/file/d/1zgQHr6zF-AXNTLOWyyM-k50fd8CGVez6/view?usp=drive_link",
            showImage: false,
        },
        {
            head: "כתבות כנס אילת",
            name: "כתבה 2",
            ref: "https://drive.google.com/file/d/14SZLl5MXebhXxWd1pJevZFkEyApX9cb7/view?usp=drive_link",
            showImage: false,
        },
    ]
}

var eilatConferencePhotos = {
    items: [
        {
            head: "תמונות מהכנס באילת",
            name: "תמונות מהכנס 1",
            ref: "https://drive.google.com/file/d/1uR1ajRAW4NkGdPND4nTH4Vx-VgG2UqGq/view?usp=sharing",
            showImage: false,
        },
        {
            head: "תמונות מהכנס באילת",
            name: "תמונות מהכנס 2",
            ref: "https://drive.google.com/file/d/1tPhkPsg3vEB4mnL7xrgF9W3eMt3mDqXa/view?usp=sharing",
            showImage: false,
        },
        {
            head: "תמונות מהכנס באילת",
            name: "תמונות מהכנס 3",
            ref: "https://drive.google.com/file/d/1vLY6PW5CI9XM046sPy_ED1i311ytigzX/view?usp=sharing",
            showImage: false,
        },
        {
            head: "תמונות מהכנס באילת",
            name: "תמונות מהכנס 4",
            ref: "https://drive.google.com/file/d/1mOmeQTzxwrlpegAhK3Zflp58A1kwh5Ie/view?usp=sharing",
            showImage: false,
        },
        {
            head: "תמונות מהכנס באילת",
            name: "תמונות מהכנס 5",
            ref: "https://drive.google.com/file/d/1LUnwm37eb45hzezauQlG26akyCSux3lm/view?usp=sharing",
            showImage: false,
        },
        {
            head: "תמונות מהכנס באילת",
            name: "תמונות מהכנס 6",
            ref: "https://drive.google.com/file/d/1CAFHlpOfJgLrRi_2h5fjq-_nWDIktfaH/view?usp=sharing",
            showImage: false,
        },
        {
            head: "תמונות מהכנס באילת",
            name: "לוז כנס אילת",
            ref: "https://drive.google.com/file/d/1cCi04z6lF0BRMhWJX1QYrsG08hQgzylV/view?usp=sharing",
            showImage: false,
        },
        {
            head: "תמונות מהכנס באילת",
            name: "ערב פתיחה כנס אילת",
            ref: "https://drive.google.com/file/d/1GIiFPwZbOZjzUgkJ8ElvoSB27UwXYmPB/view?usp=sharing",
            showImage: false,
        }
    ]
}

var financialConference = {
    items: [
        {
            head: "ועידה הפיננסית של האיגוד 2026",
            name: "הזמנה",
            ref: "https://drive.google.com/file/d/1I_AEDTA-4Zm5qi6gAjcYTXf_hf6LB58_/view?usp=sharing",
            showImage: false,
        },
    ]
}

var regulations = {
    items: [
        {
            head: "תקנון האיגוד",
            name: "תקנון האיגוד",
            ref: "https://drive.google.com/file/d/1uIoSJvwGqK3LMHih0q4WfyJlOKh4oxEm/view?usp=drive_link",
            showImage: false,
        },
    ]
}

var register = {
    items: [
        {
            head: "כיצד נרשמים ומצרפים קולגה",
            name: "כיצד נרשמים ומצרפים קולגה",
            ref: "https://drive.google.com/file/d/1klEzkWBKKEokNR7S8cJzWdkMwTRZkZtq/view?usp=drive_link",
            showImage: false,
        }
    ]
}

export {
    benefits,
    businessDevelopment,
    whatsUnion,
    hiveOfExperts,
    legalRepresentation,
    diploma,
    professionalGroups,
    Year2026,
    Year2025,
    Year2024,
    Newsletters,
    professionalSpace,
    realizationBenefits,
    publishedArticles,
    associationIncorporation,
    Events,
    VertHotelConference,
    danHotelConference,
    eilatConferenceArticles,
    eilatConferencePhotos,
    financialConference,
    regulations,
    register,
};
